import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import AuthBody from './AuthBody';
import styles from './styles/AuthForm.module.css';

const AuthForm = () => {
    const location = useLocation();
    const [authMode, setAuthMode] = useState(location.state?.authMode || 'login');
    const [acceptInvite, setAcceptInvite] = useState(location.state?.acceptInvite || 'false');

    const isRegister = authMode === 'sign up';

    return (
        <div className={styles.wrapper}>
            <div className={`${styles.container} ${isRegister ? styles.containerHidden : ''}`}>
                <div className={`${styles.leftHalf} ${styles.loginLeft}`}>
                    {authMode === 'forgot password' ? (
                        <ForgotPassword setAuthModalState={setAuthMode} />
                    ) : (
                        <Login setAuthModalState={setAuthMode} acceptInvite={acceptInvite} />
                    )}
                </div>
                <div className={`${styles.rightHalf} ${styles.loginRight}`}>
                    <AuthBody />
                </div>
            </div>
            <div className={`${styles.container} ${isRegister ? '' : styles.containerHidden}`}>
                <div className={`${styles.leftHalf} ${styles.registerLeft}`}>
                    <AuthBody />
                </div>
                <div className={`${styles.rightHalf} ${styles.registerRight}`}>
                    <Register setAuthModalState={setAuthMode} acceptInvite={acceptInvite} />
                </div>
            </div>
        </div>
    );
};

export default AuthForm;
